import { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import EmailIcon from '@mui/icons-material/Email';
import LoginIcon from '@mui/icons-material/Login';
import { useDispatch, useSelector } from 'react-redux';
import { openModal } from '../../reducers/modal';
import { getCurrentUser, isUserSignedIn } from '../../reducers/currentUser';
import { modalTypes } from '../modal/Modal';
import mbiLogo from '../../assets/MBI-Logo2.png';
import IconButton from '../IconButton';
import AccountDetails from './AccountDetails';

const useStyles = ({ height }) => ({
  header: {
    width: '100vw',
    height,
    background: '#ffffff',
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
  },
  headerRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  logo: {
    margin: 5,
    maxHeight: height,
    padding: '10px 20px',
  },
  title: {
    color: '#003366',
    marginLeft: '10px',
  },
  button: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: '#003366',
    padding: '0',
    margin: '0',
  },
});

const buttonConfigs = {
  login: <IconButton
    Icon={LoginIcon}
    text="Login"
    href="/login"
    size={36}
  />,
  logout: <AccountDetails />,
};

const startEmail = () => { window.open('mailto:mapfeedback@masstech.org'); };

const DesktopHeader = ({ height }) => {
  const styles = useStyles({ height });
  const isSignedIn = useSelector(isUserSignedIn);

  const dispatch = useDispatch();

  const openAbout = () => {
    dispatch(openModal({ type: modalTypes.ABOUT_MODAL }));
  };

  const openHelp = () => {
    dispatch(openModal({ type: modalTypes.HELP_MODAL }));
  };

  useEffect(() => {
    const dontShowModal = localStorage.getItem('dontShowModal');
    if (!dontShowModal) openAbout();
    dispatch(getCurrentUser());
  }, []);

  return (
    <header style={styles.header}>
      <div id="header-left" style={styles.headerLeft}>
        <a href="https://broadband.masstech.org">
          <img src={mbiLogo} alt="MBI Logo" style={styles.logo} />
        </a>
        <Typography variant="h5" component="h1" style={styles.title}>
          Massachusetts Broadband Map - PUBLIC BETA
        </Typography>
      </div>
      <div id="header-right" style={styles.headerRight}>
        <IconButton text="Contact Us" Icon={EmailIcon} onClick={startEmail} />
        <IconButton text="About" Icon={InfoIcon} onClick={openAbout} />
        <IconButton text="Help" Icon={HelpIcon} onClick={openHelp} />
        {isSignedIn ? buttonConfigs.logout : buttonConfigs.login}
      </div>
    </header>
  );
};

export default DesktopHeader;
